import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Skeleton from "../shared/skeleton";
import Textbox from "../_lib/input/textbox";
import Textarea from "../_lib/input/textarea";
import { submit, get } from '../../actions/a.simple-order-form'
import { notify } from "../../util";

const SimpleOrderForm = () => {
    const formRef = useRef();
    const initialState = {
        isSubmiting: false,
        FirstName: '',
        LastName: '',
        Mobile: '',
        Email: '',
        Description: '',
        Files: {}
    }
    const [formState, setFormState] = useState(initialState);
    const [readyToSubmit, setReadyToSubmit] = useState(false);
    const dispatch = useDispatch();
    const { isFetching, extenstionsWhitelist } = useSelector((state) => state.SimpleOrder);

    const handleSubmit = async (formState) => {
        let formData = new FormData(),
            { FirstName, LastName, Email, Mobile, Description } = formState,
            { Files } = formState;
        for (const [key, file] of Object.entries(Files)) {
            formData.append(`${key}`, new Blob([file], { type: 'application/octet-stream' }), file.name)
        }
        formData.append(
            "Data",
            new Blob([JSON.stringify({ FirstName, LastName, Email, Mobile, Description })], {
                type: "application/json",
            })
        )
        dispatch(submit(formData));
    };

    const handleSelectFile = (e) => {
        let file = e.target.files[0];
        if (file.size <= 26214400) {
            let inputName = e.target.name;
            let splittedFileName = file.name.split(".");
            let fileExtension = `.${splittedFileName[splittedFileName.length - 1]}`;
            if (extenstionsWhitelist.includes(fileExtension)) {
                setFormState((oldState) => ({ ...oldState, Files: { ...(oldState.Files), [inputName]: file } }));
            }
            else {
                e.target.value = ""
                notify.show({ message: "نوع فایل معتبر نیست", type: "error" })
            }
        } else {
            e.target.value = ""
            notify.show({ message: "حجم فایل ارسالی باید حداکثر ۲۵مگابایت باشد", type: "error" })
        }
    }

    useEffect(() => {
        dispatch(get());
    }, [])

    useEffect(() => {
        $(formRef.current).checkify({
            message: {
                position: "right",
                required: "پر کردن این فیلد الزامی است.",
                email: "فرمت اطلاعات وارد شده صحیح نیست.",
                regex: "فرمت اطلاعات وارد شده صحیح نیست.",
                between: "فرمت اطلاعات وارد شده صحیح نیست.",
                number: "در این فیلد فقط می توانید عدد وارد کنید.",
                maxlen: "بیشترین تعداد کاراکتر مجاز {count} است.",
                minlen: "کمترین تعداد کاراکتر مجاز {count} است.",
            },
            onValid: (e) => {
                e.preventDefault();
                setReadyToSubmit(true);
                setFormState((oldState) => ({ ...oldState, isSubmiting: true }));
            },
            onError: () => console.error(formState),
        })
    }, [formState])

    useEffect(() => {
        if (readyToSubmit) {
            handleSubmit(formState);
            setFormState(initialState);
            setReadyToSubmit(false);
        }
    }, [readyToSubmit])

    if (isFetching)
        return (
            <div className="simple-order__form-cn">
                <h4>فرم درخواست سفارش</h4>
                <Skeleton
                    align="center"
                    width={100}
                    schema={skeletonSchema}
                    animation="blink"
                />
            </div>
        );

    return (
        <div className="simple-order__form-cn">
            <h4>فرم درخواست سفارش</h4>
            <form ref={formRef} className="simple-order__form">
                <div className="row">
                    <div className="col-sm-6 form-group">
                        <Textbox
                            label="نام (الزامی)"
                            name="FirstName"
                            value={formState.FirstName}
                            onChange={(e) => { setFormState((oldState) => ({ ...oldState, FirstName: e.target.value })) }}
                            //required={true}
                            {...{ maxLength: 50, 'data-checkify': 'required' }}
                        />
                    </div>
                    <div className="col-sm-6 form-group">
                        <Textbox
                            label="نام خانوادگی (الزامی)"
                            name="LastName"
                            value={formState.LastName}
                            onChange={(e) => { setFormState((oldState) => ({ ...oldState, LastName: e.target.value })) }}
                            //required={true}
                            {...{ maxLength: 50, 'data-checkify': 'required' }}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-6 form-group">
                        <Textbox
                            label="ایمیل"
                            name="Email"
                            value={formState.Email}
                            onChange={(e) => { setFormState((oldState) => ({ ...oldState, Email: e.target.value })) }}
                        />
                    </div>
                    <div className="col-sm-6 form-group">
                        <Textbox
                            label="شماره همراه (الزامی)"
                            name="Mobile"
                            value={formState.Mobile}
                            onChange={(e) => { setFormState((oldState) => ({ ...oldState, Mobile: e.target.value })) }}
                            //required={true}
                            {...{ maxLength: 11, 'data-checkify': 'required,number' }}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 form-group">
                        <Textarea
                            label="توضیحات (الزامی)"
                            name="Description"
                            value={formState.Description}
                            onChange={(e) => { setFormState((oldState) => ({ ...oldState, Description: e.target.value })) }}
                            //required={true}
                            {...{ maxLength: 1000, rows: 5, 'data-checkify': 'required' }}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-6 form-group">
                        <input name="File1" type="file" onChange={handleSelectFile} />
                    </div>
                    <div className="col-sm-6 form-group">
                        <input name="File2" type="file" onChange={handleSelectFile} />
                    </div>
                    <div className="col-sm-6 form-group">
                        <input name="File3" type="file" onChange={handleSelectFile} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-3">
                        <button
                            disabled={formState.isSubmiting}
                            type="submit"
                            className="btn btn-info btn-block"
                        >
                            ثبت
                        </button>
                    </div>
                </div>
            </form >
        </div >
    );
};

const skeletonSchema = [[[48, 40]], [[48, 40]], [[48, 40]], [[48, 40]], [[100, 110]], [[48, 25], [48, 25], [48, 25]], [[53, 45]]];

export default SimpleOrderForm;